export default __webpack_public_path__ + "static/media/white-horse.488da946.jpg";